import React from "react";
import { Box, Typography, Container } from "@mui/material";

const imageUrl = "contactbanner.webp";

const About = () => {
  return (
    <>
      <Container maxWidth="xl" sx={{ mt: 12 }}>
        <Box
          sx={{
            height: 400,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            position: "relative",
            backgroundImage: `url(${imageUrl})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            color: "#fff",
            textAlign: "center",
            p: 3,
            marginTop: 2,
            "&:before": {
              content: '""',
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1,
            },
          }}
        >
          <Box sx={{ position: "relative", zIndex: 1 }}>
            <Typography variant="h2" gutterBottom>
              About Us
            </Typography>
            <Typography variant="h6" gutterBottom>
              Discover the taste of perfection
            </Typography>
          </Box>
        </Box>
      </Container>
      <Container maxWidth="md" sx={{ my: 4 }}>
        <Box>
          <Typography variant="body1" paragraph>
            Foody is a revolutionary online food ordering platform that brings
            the best culinary experiences right to your doorstep. We are
            passionate about delivering delicious, high-quality meals from the
            finest restaurants and kitchens in your area.
          </Typography>
          <Typography variant="body1" paragraph>
            Our mission is to provide a seamless and enjoyable dining
            experience, whether you're craving your favorite comfort food or
            exploring new flavors. With Foody, you can browse through an
            extensive menu of mouthwatering options, conveniently place your
            order, and savor every bite in the comfort of your own home or
            office.
          </Typography>
          <Typography variant="body1" paragraph>
            At Foody, we believe in supporting local businesses and promoting
            sustainable practices. We work closely with our restaurant partners
            to ensure that every dish is prepared with the freshest ingredients
            and utmost care. Our user-friendly platform and efficient delivery
            services make it easy for you to indulge in culinary delights while
            saving time and hassle.
          </Typography>
          <Typography variant="body1" paragraph>
            Join the Foody community today and embark on a delectable journey of
            flavors. Discover the convenience of online ordering and let us take
            care of your cravings, one delicious meal at a time.
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default About;
